import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ILocationList } from '../../../Pages/Location/ILocation';

export const AddLocationSlicer = createSlice({
  name: 'AddLocation',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ILocationList>,
  reducers: {
    addLocation: (state, _) => {
      state.isLoading = true;
    },
    successAddLocation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddLocation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddLocationState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addLocation,
  failureAddLocation,
  successAddLocation,
  clearAddLocationState,
} = AddLocationSlicer.actions;

export default AddLocationSlicer.reducer;
